export default __webpack_public_path__ + "static/media/iso_logo.1fce1d28.jpg";